
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGenericLineOverlap as ObiGenericLineOverlapElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-generic-line-overlap.js';
 
 
 

 
 export const ObiGenericLineOverlap = createComponent({
   react: React,
   tagName: 'obi-generic-line-overlap',
   elementClass: ObiGenericLineOverlapElement,
   events: {
     
   }
  });
 
 